export interface Definitionscertificate_interface {
  id:number,
  quantity_id:number,
  quantity_title:String,
  cALIBRATIONMETHOD:String,
  uNCERTAINTY:String,
  tRACEABILITY:String,
  decisionRule:String,
  username:String,
  qUANTITY_name:String,
  code:String,
  persianDate:String,
  del:boolean
}

export function Empty_Definitionscertificate_interface():Definitionscertificate_interface{
  return{
    id:0,
    quantity_id:0,
    quantity_title:'',
    cALIBRATIONMETHOD:'',
    uNCERTAINTY:'',
    tRACEABILITY:'',
    decisionRule:'',
    code:'',
    username:'',
    qUANTITY_name:'',
    persianDate:'',
    del:false
  }
}
